import { Injectable } from '@angular/core';

/**
 * Service for tracking affiliate referrals across domains
 * Captures referral IDs from Webflow marketing site and persists them for checkout
 */
@Injectable({
  providedIn: 'root'
})
export class ReferralTrackingService {
  private readonly STORAGE_KEY = 'pk_ref';

  /**
   * Initialize referral tracking by capturing from URL parameter
   * Call this on app initialization
   */
  initialize(): void {
    this.captureFromUrl();
  }

  /**
   * Capture referral ID from URL parameter (pk_ref)
   * Used when user comes from Webflow marketing site
   */
  private captureFromUrl(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const pkRef = urlParams.get('pk_ref');

    if (pkRef) {
      sessionStorage.setItem(this.STORAGE_KEY, pkRef);
    }
  }

  /**
   * Get the current referral ID with fallback chain
   * Priority: window.promotekit_referral → sessionStorage → undefined
   */
  getReferralId(): string | undefined {
    // Try window.promotekit_referral first (direct affiliate link)
    if (window.promotekit_referral) {
      return window.promotekit_referral;
    }

    // Fall back to sessionStorage (from Webflow cross-domain)
    const stored = sessionStorage.getItem(this.STORAGE_KEY);
    if (stored) {
      return stored;
    }

    return undefined;
  }

  /**
   * Clear referral ID from storage
   * Call after successful checkout to prevent false attribution
   */
  clear(): void {
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}
